import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class HospitalSettingsService {

  constructor(private api: ApiService) {}

  getSettings(hospitalCode: string): Observable<any> {
    const userId = localStorage.getItem('endUserId');
    return this.api.apiRequest('get', `pcv/hospital-settings/${hospitalCode}?userId=${userId}`, {});
  }

  configureEmail(data: { hospitalCode: string, action: string, email?: string }): Observable<any> {
    return this.api.apiRequest('post', 'pcv/hospital-settings/configure-email', {
      ...data,
      userId: localStorage.getItem('endUserId')
    });
  }

  updateEmail(data: { hospitalCode: string, email?: string, enabled?: boolean }): Observable<any> {
    return this.api.apiRequest('put', 'pcv/hospital-settings/update-email', {
      ...data,
      userId: localStorage.getItem('endUserId')
    });
  }

  removeEmail(hospitalCode: string): Observable<any> {
    return this.api.apiRequest('post', 'pcv/hospital-settings/remove-email', {
      hospitalCode,
      userId: localStorage.getItem('endUserId')
    });
  }

  isCurrentUserHospitalAdmin(): boolean {
    return localStorage.getItem('hospitalRole') === 'admin';
  }
}
